type TableFilterDTO = {
  text: string
  value: string | null
}

export type ColumnRepresentationDTO = {
  title: string
  dataIndex: string
  key: string
  render: string | null
  tableFilter: Array<TableFilterDTO> | null
  className: string | null
  isFilterable: Boolean
}

export class ColumnRepresentations {
  columnRepresentations: Array<ColumnRepresentationDTO>;

  constructor(columnRepresentations: Array<ColumnRepresentationDTO>) {
    this.columnRepresentations = columnRepresentations;
  }

  filterableColumns(): Array<string> {
    return this.columnRepresentations.filter(
      (columnRepresentation) => columnRepresentation.isFilterable)
      .map((columnRepresentation) => columnRepresentation.title);
  }

  pinnedColumns(pinnedColumns: Array<string>): Array<string> {
    return this.columnRepresentations
      .map((columnRepresentation) => columnRepresentation.title)
      .filter((columnTitle) => pinnedColumns.some((pinnedColumn) => columnTitle === pinnedColumn));
  }

  isUserColumn(columnKey: string): boolean {
    return this.columnRepresentations.find((columnRepresentation) => columnRepresentation.key === columnKey)?.title === "User";
  }
}